import React from 'react';
import PropTypes from 'prop-types';

const HeaderLine = ({ postCategory }) => (
  <div className={`border-t-8 border-${postCategory} fixed w-full z-top pin-l`} style={{ top: '64px' }} />
);

HeaderLine.propTypes = {
  postCategory: PropTypes.string,
};

HeaderLine.defaultProps = {
  postCategory: 'black',
};

export default HeaderLine;
